<div class="header-bar">
    <div class="header-left">
      <div class="header-text">{{ itemsText }}</div>
      <div class="divider"></div>
      <div class="search-box input-box">
        <svg-icon src="assets/svg/magnifier.svg"></svg-icon>
        <mat-form-field>
          <input matInput type="text" [formControl]="searchValueControl" [placeholder]="'Search ' + (itemsText | lowercase) + '...'" />
        </mat-form-field>
      </div>
      <div class="divider"></div>
      <div class="filter">
        <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
          <svg-icon
            src="assets/svg/filter.svg"
            [svgClass]="filterOpen ? 'lightGreen' : 'grey'"
          ></svg-icon>
        </button>
      </div>
      <div class="divider"></div>
      <button mat-button class="icon-btn" [matMenuTriggerFor]="columnMenu" [disabled]="filterOpen">
        <svg-icon src="assets/svg/paper-pencil.svg" svgClass="grey"></svg-icon>
      </button>
      <button *ngIf="hasActiveFilters && !filterOpen" mat-button (click)="resetAllFilters()">
        Reset Filters
      </button>

      <mat-menu
        class="mat-menu-elaphant vertical-menu column-menu"
        #columnMenu="matMenu"
      >
        <div class="column-options">
          <mat-checkbox
            *ngFor="let column of filterableColumns"
            [checked]="!!column.selected"
            color="lightGreen"
            (click)="$event.stopPropagation()"
            (change)="onColumnSelectionChange($event, column)"
            >{{ column.name }}</mat-checkbox
          >
        </div>
      </mat-menu>
    </div>
    <div class="header-center"></div>
    <div class="header-right">
      <ng-container *ngIf="!filterOpen">
        <button
          *ngIf="hasWrite && hasCheckedIntegrationMockBookings && hasIntegrationMockBookings"
          mat-button
          color="warn"
          (click)="clearIntegrationMockBookings()"
        >
          Clear Mock Booking Data
        </button>
        <!--
        <button mat-button color="lightBlue" (click)="preview()">
          Preview
        </button>
        -->
        <button *ngIf="hasWrite" mat-button color="lightGreen" (click)="create()">
          {{ createNewItemText }}
        </button>
      </ng-container>

      <ng-container *ngIf="filterOpen">
        <button mat-button color="fiord" (click)="resetFilters()">Reset</button>
        <button
          mat-button
          color="lightGreen"
          (click)="applyFilters()"
        >
          Apply filters
        </button>
      </ng-container>
    </div>
  </div>

  <!-- Advanced Filters Panel -->
  <div [hidden]="!filterOpen" class="filters-panel">
    <div class="container filters-container">
      <div class="container-header">
        <div class="text">Advanced Search Filters</div>
      </div>
      <div class="container-content">
        <div class="filter-row">
          <div class="filter-group">
            <mat-form-field>
              <mat-label>Category search</mat-label>
              <input matInput type="text" [formControl]="categorySearchControl" placeholder="Search categories..." />
            </mat-form-field>
          </div>
          <div class="filter-group">
            <mat-form-field>
              <mat-label>Tag search</mat-label>
              <input matInput type="text" [formControl]="tagSearchControl" placeholder="Search tags..." />
            </mat-form-field>
          </div>
          <div class="filter-group">
            <mat-form-field>
              <mat-label>Search mode</mat-label>
              <mat-select [formControl]="searchModeControl">
                <mat-option value="OR">OR (Any match)</mat-option>
                <mat-option value="AND">AND (All must match)</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div [hidden]="filterOpen" class="documents-list">
    <div class="container documents-container">
      <div class="container-header no-bottom-border">
        <div class="text">{{ existingItemsText }}</div>
        <div class="options">
          <button *ngIf="hasWrite" mat-icon-button [matMenuTriggerFor]="menu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu #menu="matMenu" class="vertical-menu">
            <button *ngIf="hasWrite" mat-menu-item (click)="create()" class="icon-btn-w-text">
              <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
              <span>{{ newItemText }}</span>
            </button>
          </mat-menu>
        </div>
      </div>
  
      <div class="container-content" lhpeElementLoader #elementLoader="elementloader">
        <table #documentsTable mat-table [dataSource]="dataSource" matSort>
          <!-- ID Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let d">{{ d.id }}</td>
          </ng-container>
  
                    <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let d">{{ d.name }}</td>
          </ng-container>

          <!-- Subtitle Column -->
          <ng-container matColumnDef="subtitle">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ subtitleColumnLabel }}</th>
            <td mat-cell *matCellDef="let d">{{ d.subtitle }}</td>
          </ng-container>

                      <!-- Foreign Key Column -->
          <ng-container matColumnDef="foreign_key">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Foreign Key</th>
            <td mat-cell *matCellDef="let d">{{ d.foreign_key }}</td>
          </ng-container>

          <!-- Publish Column -->
          <ng-container matColumnDef="publish">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Publish</th>
            <td mat-cell *matCellDef="let d">{{ d.publish ? 'Yes' : 'No' }}</td>
          </ng-container>

          <!-- Publish Start Date Column -->
          <ng-container matColumnDef="publish_start_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Publish Start</th>
            <td mat-cell *matCellDef="let d">{{ d.publish_start_date | date:'short' }}</td>
          </ng-container>

          <!-- Publish End Date Column -->
          <ng-container matColumnDef="publish_end_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Publish End</th>
            <td mat-cell *matCellDef="let d">{{ d.publish_end_date | date:'short' }}</td>
          </ng-container>

          <!-- Bookable Column (Aura only) -->
          <ng-container matColumnDef="bookable" *ngIf="isAura">
            <th mat-header-cell *matHeaderCellDef>Bookable</th>
            <td mat-cell *matCellDef="let d">{{ isBookableDocument(d) ? 'Yes' : 'No' }}</td>
          </ng-container>

          <!-- Categories Column -->
          <ng-container matColumnDef="categories">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Categories</th>
            <td mat-cell *matCellDef="let d">{{ getSortedCategoryNames(d.documentCategoryKeywords) }}</td>
          </ng-container>

          <!-- Options Column -->
          <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let d" class="options-cell">
              <button *ngIf="hasWrite && hasDetail" mat-button class="icon-btn" (click)="edit(d)">
                <svg-icon src="assets/svg/pencil.svg" svgClass="lightBlue"></svg-icon>
              </button>
              <div *ngIf="!(hasWrite && hasDetail)" class="empty-btn-space"></div>
              <button *ngIf="hasWrite" mat-button class="icon-btn" (click)="delete(d)">
                <svg-icon src="assets/svg/trashcan.svg" svgClass="lightBlue"></svg-icon>
              </button>
              <div *ngIf="!hasWrite" class="empty-btn-space"></div>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
  
        <mat-paginator
          [pageSizeOptions]="pageSizeOptions"
          [pageSize]="perPage"
          (page)="onPageChange($event)"
        ></mat-paginator>
      </div>
    </div>
  </div>